<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb class="breadcrumb-container" />

    <UpdatePassword ref="updatePassword" />

    <div class="right-menu">
      <div class="avatar-container">
        <div class="avatar-wrapper">
          <!-- <div class="message-bell" @click="messageClick()">
            <el-badge :value="messgaeCount" class="message">
              <i class="el-icon-message-solid" style="font-size: 20px;" />
            </el-badge>
          </div> -->
          <!-- <el-dropdown trigger="click"> -->
          <el-dropdown trigger="hover">
            <img :src="avatar" class="user-avatar">
            <div class="avatar-name ">{{ name }}</div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
              <router-link to="/">
                <el-dropdown-item>
                  <span style="display:block;">首页</span>
                </el-dropdown-item>
              </router-link>
              <router-link to="/screen">
                <el-dropdown-item divided>
                  <span style="display:block;">大屏页</span>
                </el-dropdown-item>
              </router-link>
              <el-dropdown-item divided @click.native="updatePwd()">
                <span style="display:block;">修改密码</span>
              </el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">
                <span style="display:block;">退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import UpdatePassword from '@/components/UpdatePassword'
import { checkPermission } from '@/utils/permission'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    UpdatePassword
  },

  data() {
    return {
      messageCount: 0,
      showOperate: checkPermission('personalCenter'),
      avatar: require('@/assets/user.png?imageView2/1/w/80/h/80')
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'name'])
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    },
    updatePwd() {
      this.$refs.updatePassword.open()
    },
    handleCommand(command) {
      if (command == 'updatePwd') {
        this.updatePwd()
      }
    },
    personalCenter() {
      this.$router.push('/sys/personalCenter')
    },
    toWorkIndex() {
      this.$router.push('/sys/workIndex')
    },
    /**
     *打开消息详情页面
     */
    messageClick() {
      // this.$router.push('/smart/alarmLog')
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          margin-left: 20px;
          border-radius: 10px;
        }
        .avatar-name {
          height: 40px;
          border-radius: 10px;
          display: -webkit-inline-box;
          float: left;
        }
        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

.message-bell {
  height: 40px;
  float: left;
  margin-right: 20px;
  padding-top: -10px;
  margin-top: -3px;
}
.el-badge.message {
  margin-top: 1px;
}
</style>
